export default __webpack_public_path__ + "static/media/third.f5f8526b.png";